// extracted by mini-css-extract-plugin
export default {"Row":"📚19-10-2IAuGr","Label":"📚19-10-2agDbH","Side":"📚19-10-2FGC_e","Secondary":"📚19-10-2kGYru","Prefix":"📚19-10-2hWl6j","Suffix":"📚19-10-2k6MzQ"};